<template>
    <header class="marginbottom20" id="top">
        <div class="center width100" id="menu-back" style="">
            <div class="return_section">
                <div style="text-align:right;float:left;">
                    <a style="" :href="correctReturnLink">
                        <span class="menu-tekst bold font14">
                            <font-awesome-icon icon="arrow-left" />
                            Keer terug naar de website
                        </span>
                    </a>
                </div>
            </div>
        </div>
        <div class="clear" style="border-top: 1px solid #efefef;"></div>
        <div class="center" id="top-bar" style="width: 80%; max-width: 1200px">
            <div class="paddingtop10 widthauto">
                <div id="logo">
                    <a href="/">
                        <span v-if="rivierOnly" style="color: #1F8234; padding-top:40px;" class="font30 "> RivierCruiseReizen </span>
                        <span v-else class="cruise-logo" id="cruise-logo"></span>

                    </a>
                </div>

                <div class="info paddingbottom10">
                    <div class="topmenu paddingtop10">
                        <ul class="bel">
                            <div
                                style="font-size: 12px; margin-right: 20px; padding-bottom: 5px;"
                            >
                                Bel direct met een cruisespecialist:
                            </div>

                            <li class="item288">
                                <span class="tel"
                                    >
                                    <font-awesome-icon
                                        v-if="!rivierOnly"
                                        flip="horizontal"
                                        icon="phone"
                                        style="font-size: 17px;"
                                    />

                                    <font-awesome-icon
                                            v-else
                                            flip="horizontal"
                                            icon="phone"
                                            style="font-size: 17px; color: #1F8234;"
                                    />
                                    <a v-if="!rivierOnly" href="tel:0107200500"
                                        style="color: inherit; font: inherit">
                                        010 - 7 200 500</a>
                                       <a v-else href="tel:0100000000"
                                          style="color: #1F8234;">
                                        010 - 0 000 000</a>
                                </span
                                >
                                <div class="tijden margintop5">
                                    <div class="floatright textright">
                                        <div class="tijden" style="float:left;">
                                            Ook via WhatsApp: 06 1515 33 44
                                        </div>
                                        <div
                                            class="marginleft5"
                                            style="float:left;"
                                        >
                                            <a
                                                href="https://api.whatsapp.com/send?phone=31615153344"
                                                target="_blank"
                                                ><span
                                                    class="whatsapp-img height20"
                                                ></span
                                            ></a>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <ul class="logos-img" id="bar-icons">
                            <li>
                                <a
                                    href="/anvr-algemene-nederlandse-vereniging-voor-reisondernemingen"
                                    ><span class="anvr-img"></span
                                ></a>
                            </li>
                            <li>
                                <a
                                    href="/sgr-stichting-garantiefonds-reisgelden"
                                    ><span class="sgr-img"></span
                                ></a>
                            </li>
                            <li>
                                <a
                                    href="/calamiteitenfonds-stichting-calamiteitenfonds-reizen"
                                    ><span class="cal-img"></span
                                ></a>
                            </li>
                            <li><span class="clia-img"></span></li>
                        </ul>
                    </div>
                </div>
                <div class="cd-main-header">
                    <ul class="cd-header-buttons" v-if="activeStep && activeStep > 1">

                            <font-awesome-icon
                                icon="arrow-left"
                                style="font-size: 24px;position: absolute;top: 10px; left: -55px; background: #fff;color: #333; border-radius: 50%;width:20px; height: 20px;padding: 7px;line-height: 23px;    margin-left: -17px;"
                              v-on:click="$emit('step-minus-click')"
                            />


                    </ul>  <ul class="cd-header-buttons" v-else>
                        <a :href="'/cruise/' + cruise.id">
                            <font-awesome-icon
                                icon="arrow-left"
                                style="font-size: 24px;position: absolute;top: 10px; left: -55px; background: #fff;color: #333; border-radius: 50%;width:20px; height: 20px;padding: 7px;line-height: 23px;    margin-left: -17px;"
                            />
                        </a>

                    </ul>
                </div>
            </div>
        </div>

        <div class="clear"></div>
    </header>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faArrowLeft,
    faCheck,
    faPhone,
} from '@fortawesome/free-solid-svg-icons'

library.add(faArrowLeft, faCheck, faPhone)

export default {
    name: 'Header',
    props: {
        cruise: Object,
        activeStep: Number,
    },
    computed: {
        // Check if riviercruises
        rivierOnly: function() {
            var host = window.location.hostname
            //var host = 'rivier' dev
            return host.includes("rivier");
        },
        correctReturnLink: function() {
            let slug = '/cruise/'
            return slug + this.cruise.id
        },
    },
}
</script>

<style lang="scss" scoped>
p,
a,
div {
    font-family: Ubuntu, sans-serif;
    color: #7f8386;
}
.return_section {
    max-width: 1200px;
    width: 100%;
    margin: 0 auto;
    float: none !important;
    height: 40px;
    line-height: 40px;
}

.hoofdmenu {
    border-top: 1px solid #efefef;

    > div {
        max-width: 1200px;
        width: 100%;
        margin: 0 auto;
        float: none !important;
    }

    .info {
        float: right;
    }

    .logo {
        float: left !important;
        width: 200px;
    }
}
</style>
